import { render, staticRenderFns } from "./CategoryListTable.vue?vue&type=template&id=a0b7c1a8"
import script from "./CategoryListTable.vue?vue&type=script&lang=js"
export * from "./CategoryListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports